import React from 'react';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import useIconSizeForButtonSize from '@wix/da-ds/pkg/Buttons/hooks/useIconSizeForButtonSize';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
const NullIcon = ()=>/*#__PURE__*/ React.createElement("span", {
        style: {
            display: 'block',
            width: '1px',
            height: '24px'
        }
    });
const NullIcon16 = ()=>/*#__PURE__*/ React.createElement("span", {
        style: {
            display: 'block',
            width: '1px',
            height: '16px'
        }
    });
const DummySubscribedVariant = ({ className, size = 'medium', href, onClick })=>{
    const { t } = useTranslation();
    const iconSize = useIconSizeForButtonSize(size);
    const icon = iconSize === IconSize.SMALLER ? NullIcon16 : NullIcon;
    return /*#__PURE__*/ React.createElement(SolidButton, {
        className: className,
        size: size,
        variant: 'approval-green',
        priority: "secondary",
        href: href,
        icon: icon,
        onClick: onClick
    }, t('deviation.tier.subscribed'));
};
DummySubscribedVariant.displayName = 'DummySubscribedVariant';
export default DummySubscribedVariant;

//# sourceMappingURL=DummySubscribed.js.map